import axios from "axios";
import Swal from "sweetalert2";

const deleteConfirm = async (url, refreshFn) => {
    const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) return;

    try {
        const res = await axios.delete(url, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        });

        console.log("DELETE RESPONSE:", res.data);

        await Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: res?.data?.message || "Item deleted successfully",
        });

        if (typeof refreshFn === "function") {
            await refreshFn();
        }
    } catch (error) {
        console.error("DELETE ERROR:", error.response?.data || error.message);

        Swal.fire({
            icon: "error",
            title: "Delete failed",
            text:
                error?.response?.data?.message ||
                error?.message ||
                "Something went wrong",
        });
    }
};

export default deleteConfirm;